import React, { useState, useEffect } from 'react';
import { 
  LayoutDashboard, History, IndianRupee, Briefcase, 
  UserCircle, ArrowLeft, Settings, Bell, Image as ImageIcon 
} from 'lucide-react';

// Import Pages
import WorkerHome from './pages/WorkerHome'; 
import WorkerHistory from './pages/WorkerHistory';
import WorkerPaymentView from './pages/WorkerPaymentView';
import VacanciesView from './pages/VacanciesView';
import WorkerProfileView from './pages/WorkerProfileView';

// --- VOICE GUIDE IMPORTS ---
import { useWorkerSmartGuide } from './useWorkerSmartGuide';
import FloatingVoiceAI from '../../FloatingVoiceAI';
import WorkerHeader from '../ui/WorkerHeader';
import WorkerBottomNav from '../ui/WorkerBottomNav';

const API_BASE = 'https://mukadampro.shirpur.store';

// --- SETTINGS MODAL COMPONENT ---
const SettingsModal = ({ onClose, currentBg, setAppBg, notifOn, setNotifOn, handleVoiceClick, theme, setTheme }) => {
    const wallpapers = [
        { id: 1, color: "url('/1.jpg') center / cover no-repeat fixed", name: 'Wallpaper 1' },
        { id: 2, color: "url('/2.jpg') center / cover no-repeat fixed", name: 'Wallpaper 2' },
        { id: 3, color: "url('/3.jpg') center / cover no-repeat fixed", name: 'Wallpaper 3' },
        { id: 4, color: "url('/4.jpg') center / cover no-repeat fixed", name: 'Wallpaper 4' },
        { id: 5, color: "url('/5.jpg') center / cover no-repeat fixed", name: 'Wallpaper 5' },
        { id: 6, color: "url('/6.jpg') center / cover no-repeat fixed", name: 'Wallpaper 6' },
        { id: 7, color: "url('/7.jpg') center / cover no-repeat fixed", name: 'Wallpaper 7' },
        { id: 8, color: "url('/8.jpg') center / cover no-repeat fixed", name: 'Wallpaper 8' },
        { id: 9, color: "url('/9.jpg') center / cover no-repeat fixed", name: 'Wallpaper 9' },
        { id: 10, color: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)', name: 'Winter Sky' },
        { id: 11, color: 'linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%)', name: 'Lavender' },
    ];

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: currentBg, zIndex: 9999, display: 'flex', flexDirection: 'column' }}>
            <div style={styles.header}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <button onClick={() => { window.speechSynthesis.cancel(); onClose(); }} style={styles.backBtn}>
                        <ArrowLeft size={20} color="#111" />
                    </button>
                    <h1 style={styles.headerTitle}>Settings</h1>
                </div>
            </div>
            
            <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
                <div style={{ background: 'rgba(255, 255, 255, 0.25)', backdropFilter: 'blur(16px)', borderRadius: '24px', border: '1px solid rgba(255, 255, 255, 0.3)', padding: '16px' }}>
                    
                    {/* 🌟 NEW: HIGH-LEVEL TEXT SIZE CONTROLLER SLIDER 🌟 */}
                    <div style={{display: 'flex', flexDirection: 'column', gap: '12px', padding: '14px', background: 'rgba(255,255,255,0.4)', borderRadius: '16px', marginBottom: '16px', border: '1px solid rgba(255,255,255,0.5)'}}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                                <Settings size={18} color="#111" />
                                <span style={{fontSize: '13px', fontWeight: '800', color: '#111'}}>Text Size (अक्षर का साइज़)</span>
                            </div>
                            <span style={{fontSize: '11px', fontWeight: '900', background: '#111', color: '#fff', padding: '3px 10px', borderRadius: '8px'}}>
                                {theme.textSize}px
                            </span>
                        </div>
                        <input 
                            type="range" 
                            min="10" 
                            max="18" 
                            step="1"
                            value={theme.textSize} 
                            onChange={(e) => {
                                const newSize = parseInt(e.target.value);
                                setTheme(prev => ({ ...prev, textSize: newSize }));
                                localStorage.setItem('appTextSize', newSize);
                                window.dispatchEvent(new Event('appThemeChanged')); // तुरंत पूरी स्क्रीन पर अपडेट ट्रिगर करें
                            }}
                            style={{
                                width: '100%',
                                accentColor: '#111',
                                cursor: 'pointer',
                                height: '6px',
                                borderRadius: '3px',
                                background: 'rgba(0,0,0,0.1)',
                                outline: 'none',
                                margin: '8px 0'
                            }}
                        />
                        <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '9px', color: '#111', fontWeight: '700', opacity: 0.7}}>
                            <span>A- (छोटा)</span>
                            <span>Normal (12px)</span>
                            <span>A+ (बड़ा)</span>
                        </div>
                    </div>

                    {/* Notifications Toggle */}
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px', background: 'rgba(255,255,255,0.4)', borderRadius: '16px', marginBottom: '16px', border: '1px solid rgba(255,255,255,0.5)'}}>
                        <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                            <Bell size={18} color="#111" />
                            <span style={{fontSize: '13px', fontWeight: '800', color: '#111'}}>App Notifications</span>
                        </div>
                        <div onClick={(e) => handleVoiceClick(e, "नोटिफिकेशन्स बदलने के लिए दोबारा क्लिक करें", () => setNotifOn(!notifOn), 'toggle-notif')} style={{ width: '40px', height: '22px', borderRadius: '12px', background: notifOn ? '#10B981' : 'rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', padding: '2px', cursor: 'pointer', transition: 'background 0.3s ease' }}>
                            <div style={{ width: '18px', height: '18px', borderRadius: '50%', background: 'white', transform: notifOn ? 'translateX(18px)' : 'translateX(0)', transition: 'transform 0.3s ease' }} />
                        </div>
                    </div>

                    {/* Change Wallpaper */}
                    <div style={{display: 'flex', flexDirection: 'column', gap: '14px', padding: '14px', background: 'rgba(255,255,255,0.4)', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.5)'}}>
                        <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                            <ImageIcon size={18} color="#111" />
                            <span style={{fontSize: '13px', fontWeight: '800', color: '#111'}}>Change Wallpaper</span>
                        </div>
                        <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '4px'}}>
                            {wallpapers.map(wp => (
                                <div 
                                    key={wp.id} 
                                    onClick={(e) => handleVoiceClick(e, "वॉलपेपर बदलने के लिए दोबारा क्लिक करें", () => setAppBg(wp.color), `btn-wallpaper-${wp.id}`)}
                                    style={{
                                        width: '32px', height: '32px', borderRadius: '50%', background: wp.color, cursor: 'pointer',
                                        border: currentBg === wp.color ? '2px solid #111' : '2px solid rgba(255,255,255,0.6)',
                                        transform: currentBg === wp.color ? 'scale(1.1)' : 'scale(1)',
                                        transition: 'all 0.2s ease'
                                    }}
                                />
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

// --- MAIN WORKER APP ---
export default function WorkerApp({ user, onLogout, workersData, allLooms, stats }) {
  const [view, setView] = useState('dashboard');
  const [lastView, setLastView] = useState('dashboard');
  const [statsTab, setStatsTab] = useState('week');
  const [freshUser, setFreshUser] = useState(user);

  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const [appBg, setAppBg] = useState(() => localStorage.getItem('appBg') || "url('/OHOME.jpg') center / cover no-repeat fixed");
  const [notifOn, setNotifOn] = useState(() => {
      const saved = localStorage.getItem('notifOn');
      return saved !== null ? JSON.parse(saved) : true;
  });

  // 🚀 SYNCED WITH OWNER THEME ENGINE STATE
  const [theme, setTheme] = useState({
      font: localStorage.getItem('appFont') || 'Plus Jakarta Sans',
      scale: parseFloat(localStorage.getItem('appScale')) || 1.0,
      boxStyle: localStorage.getItem('appBoxStyle') || 'glass',
      boxTexture: localStorage.getItem('appBoxTexture') || 'none', 
      neonGlow: parseInt(localStorage.getItem('appNeonGlow')) || 0,
      animSpeed: localStorage.getItem('appAnimSpeed') || 'smooth',
      pageAnim: localStorage.getItem('pageAnimStyle') || 'zoom',
      textSize: parseInt(localStorage.getItem('appTextSize')) || 12,
      textColor: localStorage.getItem('appTextColor') || '#111111',
      textGlow: parseInt(localStorage.getItem('appTextGlow')) || 0,
      auroraBg: localStorage.getItem('appAuroraBg') !== 'false',
      rippleEffect: localStorage.getItem('appRippleEffect') !== 'false',
  });

// 🎙️ INJECT SMART GUIDE HOOK ENGINE
  const { voiceAssist, toggleVoiceAssist, handleVoiceClick, speakHinglish } = useWorkerSmartGuide(freshUser, view, setView);

  // 👤 PROFILE NAVIGATION HANDLER
  const handleOpenProfile = () => {
    setLastView(view);
    setView('profile');
  };

  // 🛠️ DYNAMIC ROUTER / VIEW RENDERER
  const renderView = () => {
    switch (view) {
      case 'dashboard':
        return (
          <WorkerHome
            user={freshUser}
            workersData={workersData}
            allLooms={allLooms}
            statsTab={statsTab}
            setStatsTab={setStatsTab}
            onOpenProfile={handleOpenProfile}
            stats={stats}
            appBg={appBg}
            handleVoiceClick={handleVoiceClick}
            voiceAssist={voiceAssist}
            speakHinglish={speakHinglish}
          />
        );
      case 'history':
        return <WorkerHistory user={freshUser} appBg={appBg} handleVoiceClick={handleVoiceClick} />;
      case 'payments':
        return <WorkerPaymentView user={freshUser} appBg={appBg} handleVoiceClick={handleVoiceClick} />;
      case 'vacancies':
        return <VacanciesView user={freshUser} appBg={appBg} handleVoiceClick={handleVoiceClick} />;
      case 'profile':
  // Har 10 second mein database se aane wale live stats se data read hoga
  const liveProfileUser = workersData.find(w => String(w.id) === String(user.id)) || freshUser;
  return <WorkerProfileView user={liveProfileUser} workersData={workersData} onLogout={onLogout} appBg={appBg} handleVoiceClick={handleVoiceClick} />;
      default:
        return (
          <WorkerHome
            user={freshUser}
            workersData={workersData}
            allLooms={allLooms}
            statsTab={statsTab}
            setStatsTab={setStatsTab}
            onOpenProfile={handleOpenProfile}
            stats={stats}
            appBg={appBg}
            handleVoiceClick={handleVoiceClick}
            voiceAssist={voiceAssist}
            speakHinglish={speakHinglish}
          />
        );
    }
  };

 // 🚀 CLEAN & UNIFIED THEME ENGINE LISTENER
  useEffect(() => {
      const handleThemeUpdate = () => {
          setTheme({
              font: localStorage.getItem('appFont') || 'Plus Jakarta Sans',
              scale: parseFloat(localStorage.getItem('appScale')) || 1.0,
              boxStyle: localStorage.getItem('appBoxStyle') || 'glass',
              boxTexture: localStorage.getItem('appBoxTexture') || 'none', 
              neonGlow: parseInt(localStorage.getItem('appNeonGlow')) || 0,
              animSpeed: localStorage.getItem('appAnimSpeed') || 'smooth',
              pageAnim: localStorage.getItem('pageAnimStyle') || 'zoom',
              textSize: parseInt(localStorage.getItem('appTextSize')) || 12,
              textColor: localStorage.getItem('appTextColor') || '#111111',
              textGlow: parseInt(localStorage.getItem('appTextGlow')) || 0,
              auroraBg: localStorage.getItem('appAuroraBg') !== 'false',
              rippleEffect: localStorage.getItem('appRippleEffect') !== 'false',
          });
          const savedBg = localStorage.getItem('appBg');
          if (savedBg) setAppBg(savedBg);
      };
      window.addEventListener('appThemeChanged', handleThemeUpdate);
      window.addEventListener('storage', handleThemeUpdate);
      return () => {
          window.removeEventListener('appThemeChanged', handleThemeUpdate);
          window.removeEventListener('storage', handleThemeUpdate);
      };
  }, []);

  // 🚀 GENERATE BULLETPROOF DYNAMIC TEXT SIZES (Handles all browser inline styles variations)
  const animDuration = theme.animSpeed === 'fast' ? '0.15s' : theme.animSpeed === 'relaxed' ? '0.6s' : '0.3s';
  const textMultiplier = theme.textSize / 12; 
  const usedFontSizes = [6, 7, 7.5, 8, 8.5, 9, 9.5, 10, 11, 12, 13, 14, 15, 16, 18, 20, 24, 28, 32, 40, 42];
  const dynamicTextStyles = usedFontSizes.map(size => {
      const perfectFontSize = (size * textMultiplier).toFixed(2);
      // अलग-अलग ब्राउज़र केसिंग और स्पेसिंग फ़ॉर्मेटिंग को सपोर्ट करने के लिए मल्टीपल सेलेक्टर्स
      return `
        *[style*="font-size: ${size}px"], 
        *[style*="font-size:${size}px"], 
        *[style*="font-size: ${size}PX"], 
        *[style*="font-size:${size}PX"],
        *[style*="FONT-SIZE: ${size}px"],
        *[style*="FONT-SIZE:${size}px"] { 
            font-size: ${perfectFontSize}px !important; 
        }
      `;
  }).join('\n');

  let boxCss = '';
  const intFactor = 0.5; 
  const neonFactor = theme.neonGlow / 100;
  const neonShadow = neonFactor > 0 ? `0 0 ${theme.neonGlow}px rgba(16, 185, 129, ${neonFactor}), inset 0 0 ${theme.neonGlow/2}px rgba(16, 185, 129, ${neonFactor * 0.5})` : 'none';

  let textureCSS = '';
  if (theme.boxTexture === 'grain') {
      textureCSS = `background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.15'/%3E%3C/svg%3E");`;
  } else if (theme.boxTexture === 'mesh') {
      textureCSS = `background-image: radial-gradient(rgba(0,0,0,0.1) 1px, transparent 1px); background-size: 6px 6px;`;
  } else if (theme.boxTexture === 'brushed') {
      textureCSS = `background-image: repeating-linear-gradient(45deg, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 1px, transparent 1px, transparent 4px), repeating-linear-gradient(-45deg, rgba(0,0,0,0.02) 0px, rgba(0,0,0,0.02) 1px, transparent 1px, transparent 4px);`;
  } else if (theme.boxTexture === 'carbon') {
      textureCSS = `background-image: repeating-linear-gradient(45deg, rgba(0,0,0,0.05) 25%, transparent 25%, transparent 75%, rgba(0,0,0,0.05) 75%, rgba(0,0,0,0.05)), repeating-linear-gradient(45deg, rgba(0,0,0,0.05) 25%, transparent 25%, transparent 75%, rgba(0,0,0,0.05) 75%, rgba(0,0,0,0.05)); background-position: 0 0, 8px 8px; background-size: 16px 16px;`;
  }

  const targetCards = `:is(.ui-card, .glass-panel, div[style*="background: rgba(255, 255, 255, 0.25)"], div[style*="background: rgba(255,255,255,0.25)"])`;
  const dist = 6 + (intFactor * 10);
  const blur = 12 + (intFactor * 20);

  if (theme.boxStyle === 'glass') {
      const blurAmount = 15 + (intFactor * 35);
      const bgOp = 0.05 + (intFactor * 0.3);
      boxCss = `
          ${targetCards} {
              background: linear-gradient(135deg, rgba(255,255,255, ${bgOp + 0.15}) 0%, rgba(255,255,255, ${bgOp}) 100%) !important;
              backdrop-filter: blur(${blurAmount}px) saturate(120%) !important;
              -webkit-backdrop-filter: blur(${blurAmount}px) saturate(120%) !important;
              border: 1px solid rgba(255,255,255,0.15) !important;
              border-top: 1px solid rgba(255,255,255,0.4) !important;
              border-left: 1px solid rgba(255,255,255,0.3) !important;
              box-shadow: 0 10px 40px -10px rgba(31, 38, 135, ${intFactor * 0.3}), inset 0 1px 3px rgba(255,255,255,0.6), ${neonShadow} !important;
              position: relative;
          }
          ${targetCards}::after { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; ${textureCSS} mix-blend-mode: overlay; pointer-events: none; border-radius: inherit; opacity: 0.7; }
      `;
  } else if (theme.boxStyle === 'acrylic') {
      const blurAmount = 30 + (intFactor * 50);
      const bgOp = 0.2 + (intFactor * 0.4);
      boxCss = `
          ${targetCards} {
              background: radial-gradient(circle at top left, rgba(255,255,255, ${bgOp + 0.2}), rgba(255,255,255, ${bgOp - 0.1})) !important;
              backdrop-filter: blur(${blurAmount}px) saturate(180%) brightness(110%) !important;
              -webkit-backdrop-filter: blur(${blurAmount}px) saturate(180%) brightness(110%) !important;
              border: 1px solid rgba(255,255,255,0.2) !important;
              box-shadow: 0 15px 35px 0 rgba(0, 0, 0, ${intFactor * 0.25}), inset 0 0 30px rgba(255,255,255,0.6), ${neonShadow} !important;
              position: relative;
          }
          ${targetCards}::after { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; ${textureCSS} mix-blend-mode: overlay; pointer-events: none; border-radius: inherit; opacity: 0.8; }
      `;
  } else if (theme.boxStyle === 'solid') {
      boxCss = `
          ${targetCards} {
              background: linear-gradient(145deg, #ffffff 0%, #f3f4f6 100%) !important;
              border: 1px solid rgba(226, 232, 240, 0.8) !important;
              box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), ${neonShadow} !important;
              position: relative;
          }
          ${targetCards}::after { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; ${textureCSS} mix-blend-mode: multiply; pointer-events: none; border-radius: inherit; opacity: 0.3; }
      `;
  } else if (theme.boxStyle === 'neumorph') {
      boxCss = `
          ${targetCards} {
              background: linear-gradient(135deg, #f3f5f8, #e0e5ec) !important;
              border: 1px solid rgba(255,255,255,0.4) !important;
              box-shadow: ${dist}px ${dist}px ${blur}px rgba(163,177,198, ${0.4 + intFactor*0.3}), -${dist}px -${dist}px ${blur}px rgba(255,255,255, ${0.6 + intFactor*0.4}), ${neonShadow} !important;
              position: relative;
          }
          ${targetCards}::after { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; ${textureCSS} mix-blend-mode: multiply; pointer-events: none; border-radius: inherit; opacity: 0.2; }
      `;
  }

  const textGlowFactor = theme.textGlow / 100;
  const dynamicTextShadow = theme.textGlow > 0 ? `text-shadow: 0 0 ${2 + (textGlowFactor * 4)}px ${theme.textColor}90 !important;` : '';

  return (
    <div style={{...styles.container, background: appBg}}>
  <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fira+Sans:wght@400;600;800;900&family=Inter:wght@400;600;800;900&family=Montserrat:wght@400;600;800;900&family=Nunito:wght@400;600;800;900&family=Outfit:wght@400;600;800;900&family=Playfair+Display:wght@400;600;800;900&family=Poppins:wght@400;600;800;900&family=Plus+Jakarta+Sans:wght@400;600;800;900&family=Quicksand:wght@400;600;700&family=Raleway:wght@400;600;800;900&display=swap');
        
        html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            min-height: 100vh;
        }
        html { 
    zoom: 0.95 !important; 
    font-size: 14px !important; 
    -moz-transform: scale(0.95) !important; 
    -moz-transform-origin: top center !important; 
}
body, * {
    font-size: 14px !important;
}
        * { 
            font-family: '${theme.font}', sans-serif !important; 
            box-sizing: border-box; 
            -webkit-tap-highlight-color: transparent; 
        }
        ${dynamicTextStyles}
        h1, h2, h3, h4, h5, p, span { ${dynamicTextShadow} }
        ${boxCss}
        
        @keyframes page-zoom { 0% { opacity: 0; transform: scale(0.92); } 100% { opacity: 1; transform: none;} }
        @keyframes page-slide { 0% { opacity: 0; transform: translateY(40px); } 100% { opacity: 1; transform: none; } }
        @keyframes page-fade { 0% { opacity: 0; } 100% { opacity: 1; } }
        .page-animate { animation: page-${theme.pageAnim} ${animDuration} cubic-bezier(0.2, 0.8, 0.2, 1) forwards !important; }

        .premium-liquid-ripple {
            position: absolute; border-radius: 50%; transform: scale(0);
            animation: ripple-wave 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
            background: radial-gradient(circle, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 80%);
            pointer-events: none; width: 150px; height: 150px; margin-top: -75px; margin-left: -75px; z-index: 10;
        }
        @keyframes ripple-wave { 0% { transform: scale(0.1); opacity: 1; } 100% { transform: scale(4.5); opacity: 0; } }

        .aurora-bg-container { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 0; pointer-events: none; overflow: hidden; mix-blend-mode: hard-light; opacity: 0.85; }
        .aurora-layer { position: absolute; border-radius: 50%; filter: blur(100px); animation: aurora-float 25s infinite cubic-bezier(0.4, 0, 0.2, 1) alternate; will-change: transform; }
        .aurora-1 { width: 90vw; height: 90vh; background: rgba(37, 99, 235, 0.2); top: -20%; left: -20%; }
        .aurora-2 { width: 80vw; height: 80vh; background: rgba(16, 185, 129, 0.2); bottom: -20%; right: -10%; animation-delay: -7s; }
        @keyframes aurora-float { 0% { transform: translate(0, 0) scale(1); } 100% { transform: translate(5vw, 15vh) scale(1.2); } }
      `}</style>

      {theme.auroraBg && (
          <div className="aurora-bg-container">
              <div className="aurora-layer aurora-1" />
              <div className="aurora-layer aurora-2" />
          </div>
      )}

      {/* FLOATING VOICE AI COMPONENT */}
      <FloatingVoiceAI 
          voiceAssist={voiceAssist} 
          toggleVoiceAssist={toggleVoiceAssist} 
          handleVoiceClick={handleVoiceClick} 
      />

      {/* ===== 🌟 PREMIUM SOLID WHITE MASTER HEADER 🌟 ===== */}
      <WorkerHeader 
          user={workersData?.find(w => String(w.id) === String(freshUser?.id)) || freshUser}
          view={view}
          lastView={lastView}
          setView={setView}
          setShowSettingsMenu={setShowSettingsMenu}
          handleOpenProfile={handleOpenProfile}
          handleVoiceClick={handleVoiceClick}
      />

      {/* SCROLLABLE CONTENT */}
      <div style={styles.scrollContent}>
          {renderView()}
      </div>
      
      {/* ===== 🌟 PREMIUM SOLID WHITE BOTTOM NAVIGATION FOOTER 🌟 ===== */}
      <WorkerBottomNav 
          view={view}
          setView={setView}
          handleVoiceClick={handleVoiceClick}
      />

     {/* Settings Modal Render */}
      {showSettingsMenu && (
          <SettingsModal 
              onClose={() => setShowSettingsMenu(false)} 
              currentBg={appBg} 
              setAppBg={(newBg) => {
                  setAppBg(newBg);
                  localStorage.setItem('appBg', newBg);
              }} 
              notifOn={notifOn} 
              setNotifOn={(newNotif) => {
                  setNotifOn(newNotif);
                  localStorage.setItem('notifOn', JSON.stringify(newNotif));
              }} 
              handleVoiceClick={handleVoiceClick}
              theme={theme}
              setTheme={setTheme}
          />
      )}
    </div>
  );
}

const styles = {
    container: { 
        zoom: 0.95,
        fontSize: '14px',
        minHeight: '100vh',
        height: '100%', 
        width: '100%', 
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex', 
        flexDirection: 'column', 
        overflow: 'hidden', 
        position: 'fixed', 
        top: 0, 
        left: 0,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        transition: 'background 0.3s ease',
        WebkitOverflowScrolling: 'touch'
    },
    header: { 
        background: 'rgba(255, 255, 255, 0.25)', 
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        padding: '14px 16px', 
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent:'space-between', 
        zIndex: 20,
        flexShrink: 0
    },
    headerTitle: {
        fontSize: '16px', 
        fontWeight: '800', 
        color: '#111', 
        margin: 0, 
        letterSpacing: '-0.5px'
    },
    backBtn: { 
        background: 'rgba(255,255,255,0.4)', 
        borderRadius: '10px', 
        border: '1px solid rgba(255,255,255,0.3)', 
        cursor: 'pointer', 
        padding: '6px', 
        display: 'flex', 
        alignItems: 'center' 
    },
    scrollContent: {
        width: '100%',
        maxWidth: '600px',
        margin: '0 auto',
        flex: 1, 
        overflowY: 'auto', 
        paddingBottom: '80px', 
        position: 'relative',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    },
    profileBtn: { 
        background:'rgba(255,255,255,0.4)', 
        border:'1px solid rgba(255,255,255,0.3)', 
        borderRadius:'12px', 
        width:'36px', 
        height:'36px', 
        display:'flex', 
        alignItems:'center', 
        justifyContent:'center', 
        cursor:'pointer', 
        boxShadow:'0 4px 10px rgba(0,0,0,0.05)' 
    },
    bottomNav: { 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        width: '100%', 
        background: 'rgba(255, 255, 255, 0.3)', 
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.3)', 
        display: 'flex', 
        justifyContent: 'space-around', 
        padding: '12px 0 16px 0', 
        zIndex: 1000, 
        boxShadow: '0 -4px 30px rgba(0,0,0,0.05)' 
    },
    navItem: { 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        fontSize: '9px', 
        color: '#555', 
        gap: '4px', 
        cursor: 'pointer', 
        fontWeight: '600',
        transition: 'all 0.2s'
    },
    navItemActive: { 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        fontSize: '9px', 
        color: '#111', 
        gap: '4px', 
        cursor: 'pointer', 
        fontWeight: '800',
        transform: 'translateY(-2px)',
        transition: 'all 0.2s'
    },
};